/* Cappa purchase options: subscription plans + multi-bag blend slots.

   The previous theme drove this from its own variant picker. This theme uses a
   <variant-selects>/<variant-radios> custom element whose onVariantChange writes
   the chosen id into the form's hidden input[name="id"], so we listen for the
   bubbling change event and read that input on the next tick rather than
   duplicating the theme's option-matching logic.

   Blend slots follow the variant: one slot per bag in the box. A hidden slot's
   selects are also disabled so they are not posted as line item properties. */
(function () {
  'use strict';

  function init(root) {
    var data = root.querySelector('[data-cappa-variants]');
    if (!data) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var formId = data.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : null;

    function currentId() {
      var input = (form || document).querySelector('input[name="id"], select[name="id"]');
      return input ? parseInt(input.value, 10) : null;
    }

    function apply() {
      var id = currentId();
      if (!id) return;
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) { v = variants[i]; break; }
      }
      if (!v) return;

      // Blend slots: one per bag in the chosen pack.
      var box = root.querySelector('[data-blends]');
      if (box) {
        var want = v.slots || 1;
        box.querySelectorAll('[data-blend-slot]').forEach(function (slot) {
          var on = parseInt(slot.dataset.blendSlot, 10) <= want;
          slot.hidden = !on;
          slot.querySelectorAll('select').forEach(function (sel) { sel.disabled = !on; });
        });
        var count = box.querySelector('[data-blends-count]');
        if (count) count.textContent = want;
        var head = box.querySelector('[data-blends-head]');
        if (head) {
          head.innerHTML = 'Choose your <span data-blends-count>' + want +
                           '</span> coffee' + (want > 1 ? 's' : '');
        }
      }

      // Purchase options are priced per variant, so re-price the plan rows.
      // The chosen plan is kept when the new variant still offers it.
      var plans = root.querySelector('[data-plans]');
      if (plans && v.plans) {
        var chosen = plans.querySelector('input[name="selling_plan"]:checked');
        var keep = chosen ? chosen.value : '';
        var still = false;

        plans.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
          var label = input.closest('label');
          var price = label ? label.querySelector('.pdp__plan-price') : null;
          if (input.value === '') {
            if (price && v.price_html) price.textContent = v.price_html;
            return;
          }
          var match = null;
          for (var j = 0; j < v.plans.length; j++) {
            if (String(v.plans[j].id) === String(input.value)) { match = v.plans[j]; break; }
          }
          if (label) label.hidden = !match;
          input.disabled = !match;
          if (match) {
            if (price) price.textContent = match.price_html;
            if (input.value === keep) still = true;
          }
        });

        if (!still) {
          var onetime = plans.querySelector('input[name="selling_plan"][value=""]');
          if (onetime) onetime.checked = true;
        }
      }
    }

    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects, variant-radios, [name="id"]')) {
        setTimeout(apply, 0);
      }
    });

    apply();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cappa-purchase]').forEach(init);
  });
})();
